import React, { createContext, useContext, useEffect, useState } from 'react';
import api from '../services/api';
import { ConsultaUsuario } from '../interfaces/usuarioConsulta';
import { useAuth } from './auth';

interface UsuarioLogadoContextData {
  usuario?: ConsultaUsuario;
  carregando: boolean;
}

const UsuarioLogadoContext = createContext<UsuarioLogadoContextData>({} as UsuarioLogadoContextData);

const UsuarioLogadoProvider: React.FC = ({ children }) => {
  const { token } = useAuth();
  const [usuario, setUsuario] = useState<ConsultaUsuario>();
  const [carregando, setCarregando] = useState(true);

  useEffect(() => {
    if (!token) {
      setUsuario(undefined);
      setCarregando(false);
      return;
    }

    async function buscaUsuarioLogado() {
      const nome = localStorage.getItem('@Gscon:user');
      const { data } = await api.get('/v1/usuarios');
      const dadosUsuario = (data as ConsultaUsuario[]).find(item => item.nome === nome);
      setUsuario(dadosUsuario);
      setCarregando(false);
    }
    buscaUsuarioLogado();
  }, [token]);

  return (
    <UsuarioLogadoContext.Provider value={{ usuario, carregando }}>
      {children}
    </UsuarioLogadoContext.Provider>
  );
};

function useUsuarioLogado(): UsuarioLogadoContextData {
  const context = useContext(UsuarioLogadoContext);

  if (!context) {
    throw new Error('useUsuarioLogado é necessário usar dentro do UsuarioLogadoProvider');
  }

  return context;
}

export { UsuarioLogadoProvider, useUsuarioLogado };
